import React from "react";

const RotateLeft = ({color}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="8"
      viewBox="0 0 16 8"
      fill="none"
    >
      <path
        d="M8.20713 0.888889C6.13581 0.888889 4.25989 1.76889 2.81387 3.2L0 0V8H7.03469L4.20518 4.78222C5.29165 3.75111 6.67513 3.11111 8.20713 3.11111C10.9741 3.11111 13.3268 5.16444 14.1475 8L16 7.30667C14.9135 3.58222 11.8417 0.888889 8.20713 0.888889Z"
        fill={color}
        fillOpacity="1"
      />
    </svg>
  );
};

export default RotateLeft;
